import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlsEnum } from '@lib/enums';
import {
  IAccountAutocompleteFilter,
  IDictionaryItem,
  IEvent,
  IEventListFilters,
  IPaginationResponse,
} from '@lib/interfaces';
import { httpParamsUtil } from '@lib/utils';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventsDataService {

  constructor(
    private readonly http: HttpClient,
  ) {}

  public get(filter: IEventListFilters): Observable<IPaginationResponse<IEvent>> {
    const params = httpParamsUtil(filter);

    return this.http.get<IPaginationResponse<IEvent>>(`${environment.host}${ApiUrlsEnum.eventList}`, { params });
  }

  public accounts(filter: IAccountAutocompleteFilter): Observable<Array<IDictionaryItem>> {
    const params = httpParamsUtil(filter);

    return this.http.get<Array<IDictionaryItem>>(`${environment.host}${ApiUrlsEnum.accountsAutocomplete}`, { params });
  }
}
